import { Button, FormControlLabel, Stack, Switch, Tooltip, Typography, useTheme } from '@mui/material';
import { useSelectionContext, useYearContext } from '../../context';
import Autocomplete from '../controls/Autocomplete';
import { lloydConstants } from '../../Constants';
import { getOptionsFromObject } from '../../utils';
import { defaultSelectionValues } from '../../context/SelectionContext';
import Select from '../controls/Select';

const SelectionView = () => {
	const theme = useTheme();
	const selection = useSelectionContext();
	const { selectedYear, yearlyData } = useYearContext();

	const resetAll = () => {
		selection.setCountry(defaultSelectionValues.country);
		selection.setIncomeLevel(defaultSelectionValues.incomeLevel);
		selection.setColorBy(defaultSelectionValues.colorBy);
	};

	const getGroupedCountryOptions = () => {
		// Country coverage changes every wave, so read it off the data rather than
		// maintaining a list by hand.
		const rows = yearlyData[selectedYear];
		const surveyed = rows ? new Set(rows.map((row) => lloydConstants.countryCodeToName[row.country_code])) : null;

		return Object.entries(lloydConstants.countriesProps)
			.filter(([country]) => !surveyed || surveyed.has(country))
			.map(([country, props]) => ({
				id: country,
				label: country,
				group: props.region,
			}));
	};

	return (
		<Stack spacing={'20px'} width={'100%'}>
			<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
				<Stack spacing={1} direction={'row'} alignItems={'center'}>
					<Typography variant={'h5'}>Highlights</Typography>
					<Tooltip
						title="Select individual or multiple countries, global regions or World Bank country income groupings."
						placement="bottom"
						arrow
					>
						<span className="material-symbols-outlined" style={{ fontSize: 24, color: theme.palette.primary.main }}>
							help
						</span>
					</Tooltip>
				</Stack>
				<Button
					variant={'outlined'}
					size={'medium'}
					onClick={resetAll}
					sx={{ visibility: selection.isEmpty ? 'hidden' : 'visible' }}
				>
					Reset all
				</Button>
			</Stack>
			<Stack spacing={'20px'}>
				<Autocomplete
					options={getGroupedCountryOptions()}
					label={'Country'}
					value={selection.country}
					setValue={selection.setCountry}
					isGroup={true}
				/>
				<Autocomplete
					options={getOptionsFromObject(lloydConstants.incomeLevels)}
					label={'Country income level'}
					value={selection.incomeLevel}
					setValue={selection.setIncomeLevel}
				/>
				<Select
					options={getOptionsFromObject(lloydConstants.colorBy)}
					label={'Colour countries by'}
					value={selection.colorBy}
					setValue={selection.setColorBy}
				/>
				<FormControlLabel
					control={
						<Switch
							checked={selection.colourBlindSafe}
							onChange={(event) => selection.setColourBlindSafe(event.target.checked)}
						/>
					}
					label={
						<Tooltip
							title="Replaces the red-amber-green ramp, which is the hardest palette for the most common colour vision deficiency, with one that stays distinguishable."
							placement="bottom"
							arrow
						>
							<Typography variant={'body2'}>Colour-blind safe palette</Typography>
						</Tooltip>
					}
				/>
			</Stack>
		</Stack>
	);
};

export default SelectionView;
